import api from './api';

export const strukturOrganisasiService = {
    // PUBLIC
    getPublicStruktur: async () => {
        try {
            const response = await api.get('/struktur-organisasi');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data'
            };
        }
    },

    // ADMIN
    getStrukturList: async (params = {}) => {
        try {
            const response = await api.get('/struktur-organisasi-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getStruktur: async (id) => {
        try {
            const response = await api.get(`/struktur-organisasi-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    createStruktur: async (formData) => {
        try {
            const response = await api.post('/struktur-organisasi-admin', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    updateStruktur: async (id, formData) => {
        try {
            const response = await api.post(`/struktur-organisasi-admin/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    deleteStruktur: async (id) => {
        try {
            const response = await api.delete(`/struktur-organisasi-admin/${id}`);
            return { success: true };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    updateStatus: async (id, status) => {
        try {
            const response = await api.post(`/struktur-organisasi-admin/${id}/status`, { status });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },
};